<template>
  <v-text-field
    ref="search"
    class="search"
    :style="{ maxWidth: styleNumberWidth }"
    v-model="searchValue"
    outlined
    dense
    :placeholder="localStorage.translations.pages.common.text.search"
    hide-details
    @keyup="onQuerySearch"
  >
    <template v-slot:append>
      <svg
        v-if="searchValue === ''"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.8667 6.40001C13.8667 4.04359 11.9564 2.13334 9.59999 2.13334C7.24361 2.13334 5.33332 4.04359 5.33332 6.40001C5.33332 8.75639 7.24361 10.6667 9.59999 10.6667C11.9564 10.6667 13.8667 8.75639 13.8667 6.40001ZM9.59999 0C13.1346 0 16 2.86538 16 6.40001C16 9.93463 13.1346 12.8 9.59999 12.8C8.2178 12.8 6.93791 12.3618 5.89172 11.6168L1.82088 15.6876C1.40435 16.1041 0.728935 16.1041 0.312402 15.6876C-0.104132 15.2711 -0.104132 14.5957 0.312402 14.1791L4.38323 10.1083C3.63817 9.06209 3.19998 7.7822 3.19998 6.40001C3.19998 2.86538 6.06537 0 9.59999 0Z"
          fill="#277FAF"
        />
      </svg>
      <div class="close" v-else>
        <svg
          @click="() => onClearSearch()"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
            fill="#333333"
          />
        </svg>
      </div>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'Search',
  props: {
    maxWidth: {
      type: [Number, String],
      default: '300px',
    },
    value: { type: [String, Number], default: '' },
    routeQuery: Boolean,
  },
  data() {
    return {
      searchValue: '',
      routeQueryLoading: false,
    }
  },
  created() {
    if (this.$route.query.search || this.value) {
      this.searchValue = this.$route.query.search || this.value
    }
  },
  computed: {
    styleNumberWidth() {
      let width = this.maxWidth
      width = String(width)
      if (width.search(/%/) === -1 && width.search(/px/) === -1) {
        width = width + 'px'
      }
      return width
    },
  },
  watch: {
    $route(newData, oldData) {
      if (newData.name !== oldData.name) this.onClearSearch()
      else if (newData.query.search !== oldData.query.search) {
        if (this.searchValue !== this.$route.query.search) {
          this.searchValue = this.$route.query.search || ''
        }
      }
    },
    searchValue() {
      this.$emit('input', this.searchValue)
    },
    value() {
      if (this.value !== this.searchValue) {
        this.searchValue = this.value
        this.onQuerySearch()
      }
    },
  },
  methods: {
    onQuerySearch() {
      if (
        !this.routeQueryLoading &&
        this.routeQuery &&
        this.searchValue !== this.$route.query.search
      ) {
        this.routeQueryLoading = true
        setTimeout(() => {
          this.$routerPushQueryParams('search', this.searchValue || '')
          this.routeQueryLoading = false
        }, 2000)
      }
    },
    onClearSearch() {
      if (this.routeQuery) {
        this.$routerPushQueryParams('search', '')
      } else {
        this.searchValue = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.search:deep() {
  // max-width: 300px;
  width: 100%;
  align-self: end;
  font-size: 13px !important;
  border-radius: 10px;
  //justify-self: end;
  @media #{map-get($display-breakpoints, 'xs-only')} {
    min-width: 100%;
  }

  .v-input__slot {
    background: #ffffffff !important;
    &:not(.v-textarea) {
      height: 38px !important;
      min-height: 38px !important;
    }
    input {
      &::placeholder {
        color: #277faf;
        opacity: 1;
      }
    }
  }
  .close {
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
    svg {
      path {
        fill: #ec1b0e;
      }
    }
  }
}
// }
</style>
